import { CoreEvent, eventNames } from '@carvana/core-events';
import LinkButton from '@carvana/ds-link-button';
import { DispatcherEvent } from '@carvana/merch-native';
import NavPayloadAction from '@carvana/merch-native/NavPayloadAction';
import { useCallback } from 'react';
import { useIsNative } from '~/context/common/DeviceContext';
import { useSendMessageToNative } from '~/context/common/NativeContext';
import toastStyles from '~/hooks/common/ui/toast.module.css';
import useReplaceToast from '~/hooks/common/ui/useReplaceToast';
import HeartWithBorder from '~/icons/HeartWithBorder';
import HeartWithBorderThin from '~/icons/HeartWithBorderThin';
import { type ToastAction, type ToastView, ToastViews } from './types';

export default function useDisplayFavoritesToast() {
  const replaceToast = useReplaceToast();
  const isNative = useIsNative();
  const sendMessageToNative = useSendMessageToNative();

  return useCallback(
    (action: ToastAction, view: ToastView = ToastViews.vehicles) => {
      const isAdding = action === 'add';

      return replaceToast({
        classes: { container: toastStyles.topCenter },
        content: isAdding ? (
          <LinkButton
            data-analytics-id="Favorites"
            data-analytics-attributes={JSON.stringify({
              description: 'toast view button',
              type: view
            })}
            data-testid="favorites-toast-view"
            size="sm"
            onClick={() => {
              if (isNative) {
                sendMessageToNative(DispatcherEvent.Link, {
                  action:
                    view === ToastViews.vehicles
                      ? NavPayloadAction.ViewFavorites
                      : NavPayloadAction.ViewSavedSearches
                });
              } else {
                CoreEvent.emit(eventNames.favorites.mfe.drawer.open, {
                  tab: view
                });
              }
            }}
          >
            View
          </LinkButton>
        ) : undefined,
        dismissal: { duration: 6000, showDismissButton: false, type: 'timer' },
        header: isAdding
          ? 'Added to your favorites'
          : 'Removed from your favorites',
        icon: isAdding ? (
          <HeartWithBorderThin isFavorited />
        ) : (
          <HeartWithBorder darkGray />
        ),
        variant: 'inverse'
      });
    },
    [isNative, replaceToast, sendMessageToNative]
  );
}
